export default __webpack_public_path__ + "static/media/Book2.1ddbdedf.webp";